import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [appData, setAppdata] = useState({
    address: "",
  });

  return (
    <AppContext.Provider value={{ appData, setAppdata }}>
      {children}
    </AppContext.Provider>
  );
};